import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IActivities } from '../../Interfaces/IActivities';
import { ActivitiesService } from '../../services/activities-services';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';

@Component({
	selector: 'activity-detail',
	templateUrl: 'activity-detail.html',
	styleUrls: ['../activities.component.scss'],
})
export class ActiviyDetail {
	formGroup: FormGroup;
	loading = false;
	list: any[] = [
		{ Id: 1, Name: 'Nombre 1' },
		{ Id: 2, Name: 'Nombre 2' },
		{ Id: 3, Name: 'Nombre 3' },
	];
	dc3Hide: boolean = false;
	chemicalsubstanceHide: boolean = false;
	criticalWorkHide: boolean = false;
	max_characters: string = "";

	constructor(
		private dialogRef: MatDialogRef<ActiviyDetail>,
		@Inject(MAT_DIALOG_DATA) public data: IActivities,
		private notificationService: NotificationService,
		private activityService: ActivitiesService,
		private formBuilder: FormBuilder,
		public translate: TranslateApplicationService,
	) {
		this.formGroup = this.formBuilder.group({
			pkactivity: [data.pkactivity == null ? 0 : data.pkactivity],
			activity: [
				data.activity,
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			dc3: [data.dc3 == null ? false : data.dc3, Validators.required],
			chemicalsubstance: [data.chemicalsubstance == null ? false : data.chemicalsubstance,Validators.required],
			chkcriticalwork: [data.critical_work == null ? false : data.critical_work,Validators.required],
		});
	}
	ngOnInit() {
		if (this.formGroup.controls.pkactivity.value != 0) {
			this.dc3Hide = true;
			this.chemicalsubstanceHide = true;
			this.criticalWorkHide = true;
		}
		let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters = max_char.replace('{{ number_max }}', '255');
	}

	Save() {
		this.loading = true;
		if (this.formGroup.controls.activity.value.trim() != '' && this.formGroup.controls.activity.value != null && this.formGroup.valid) {
			this.loading = true;
			if (this.formGroup.controls.pkactivity.value == 0) {
				this.activityService.CreateActivity(this.formGroup.value).subscribe(
				(result: TransactionResult<boolean>) => {
					this.loading = false;
					if (result.success) {
						this.Alert();
						this.dialogRef.close(true);
					}
					else{
						//this.ErrorMessage('ACTIVITIES.Error_create_activity');
						this.loading = false;
					}
				},
				(error: any) => { 
					this.ErrorAlert(error); this.loading = false; 
				});
			} 
			else {
				this.activityService.UpdateActivity(this.formGroup.value).subscribe(
				(result: TransactionResult<boolean>) => {
					this.loading = false;
					if (result.data) {
						this.Alert();
						this.dialogRef.close(true);
					}
					else{
						//this.ErrorMessage('ACTIVITIES.Error_update_activity');
						this.loading = false;
					}
				},
				(error: any) => { 
					this.ErrorAlert(error); this.loading = false; 
				});
			}
		} else {
			this.loading = false;
			this.notificationService.AddAlert({
				icon: 'all_inbox',
				title: 'Warning',
				message: this.translate.TranslateKey('COMPLETE_FORM'),
				shown: true,
			});
		}
	}

	Close() {
		this.dialogRef.close(false);
	}

	Alert() {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Success',
			message: this.translate.TranslateKey('COMPLETE'),
			shown: true,
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
    }

	ErrorMessage(message: any){
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}
}
